import { put } from "redux-saga/effects";

import makeRequest from "rdx/utils/makeRequest";
import getErrorActions from "rdx/utils/getErrorActions";
import actions from "rdx/actions";
import messages from "rdx/modules/enterpriseProjects/messages";
import { camelizeKeys } from "@helpers";

function* getEnterpriseLeadOfferDetails(action) {
  const { success, data, error } = yield* makeRequest.get(`/project_offers/${action.payload.id}`, {});

  if (success && data) {
    yield put(actions.setEnterpriseLeadOfferDetails(camelizeKeys(data.body)));
  } else if (error) {
    return getErrorActions({
      error,
      message: messages.ERROR_GETTING_ENTERPRISE_LEAD_OFFER_DETAILS,
    });
  }

  return null;
}

export default getEnterpriseLeadOfferDetails;
